import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterChainNodeType } from './covance-filter-chain-node-type';

@Component({
    selector: 'covance-filter-chain-node-type',
    template: require('./covance-filter-chain-node-type.component.html'),
    styles: [require('./covance-filter-chain-node-type.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CovanceFilterChainNodeTypeComponent extends CovanceFilterBaseTypeComponent<CovanceFilterChainNodeType> {
    // TODO: Need for change detection when click the back button.
    @Input()
    public fieldValue: any;

    constructor(filterType: CovanceFilterChainNodeType) {
        super(filterType);
    }

    public onChangeSelectValues(values: string[]) {
        this.fieldVal.value = values;
        this.filterType.setQueryParamValue(this.fieldVal);
        this.filterType.onFieldChange(this.fieldVal);
    }

    public getItems() {
        return this.fieldVal.items ? this.fieldVal.items : [];
    }

    public deleteChainNode() {
        this.filterType.deleteFieldVal(this.fieldVal);
    }
}